
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bestluxurybushire() {



    const cardData =
    {
        keyword: 'Best Luxury Bus Hire in Pune',
        heading: 'Amruta Travels: Best Luxury Bus Hire in Pune',
        headingDescription: 'Amruta Travels stands out as one of Pune’s premier providers of luxury bus rental services, offering a diverse fleet tailored to meet various travel needs. Whether you are planning a corporate event, wedding, family trip, or pilgrimage, Amruta Travels ensures a seamless and comfortable journey.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

   "services": [
    {
      "name": "Premium Bus Rental Pune",
      "description": "Amruta Travels offers premium bus rental services in Pune, providing top-quality vehicles equipped with modern amenities for a comfortable and luxurious travel experience."
    },
    {
      "name": "Top Luxury Bus Service Pune",
      "description": "Experience the best in luxury travel with Amruta Travels' top luxury bus services in Pune, featuring high-end buses designed for comfort and style."
    },
    {
      "name": "Volvo/Bharat Benz/Tata AC Bus Hire",
      "description": "Choose from a range of premium buses including Volvo, Bharat Benz, and Tata AC buses for hire in Pune, ensuring a smooth and comfortable journey."
    },
    {
      "name": "Luxury Wedding Bus",
      "description": "Make your wedding celebrations special with Amruta Travels' luxury wedding bus services, offering elegant and spacious buses for transporting guests."
    },
    {
      "name": "Corporate Executive Bus Service",
      "description": "Amruta Travels provides corporate executive bus services in Pune, offering comfortable and efficient transportation solutions for business events and meetings."
    },
    {
      "name": "AC Luxury Bus for Outstation",
      "description": "Travel in comfort with Amruta Travels' AC luxury buses for outstation trips, equipped with modern amenities for a pleasant journey."
    },
    {
      "name": "Event VIP Bus Pune",
      "description": "Ensure VIP treatment for your guests with Amruta Travels' event VIP bus services in Pune, offering luxurious buses for special events."
    },
    {
      "name": "45 Seater Deluxe Bus Hire",
      "description": "Amruta Travels offers 45-seater deluxe bus hire services in Pune, providing spacious and comfortable buses for group travel."
    },
    {
      "name": "Pune to Pan India Luxury Bus",
      "description": "Travel across India in luxury with Amruta Travels' Pune to Pan India luxury bus services, offering premium buses for long-distance journeys."
    },
    {
      "name": "High-End Bus Service Pune",
      "description": "Experience high-end bus services in Pune with Amruta Travels, offering top-quality buses equipped with modern amenities for a comfortable journey."
    },
    {
      "name": "Volvo Sleeper Bus Rental",
      "description": "Amruta Travels provides Volvo sleeper bus rental services in Pune, offering comfortable and spacious buses for overnight journeys."
    },
    {
      "name": "Festival Group Bus Luxury Pune",
      "description": "Celebrate festivals in luxury with Amruta Travels' festival group bus services in Pune, offering spacious and comfortable buses for group travel."
    },
    {
      "name": "Amruta Travels Premium Buses",
      "description": "Amruta Travels offers a fleet of premium buses in Pune, providing top-quality vehicles for various travel needs."
    },
    {
      "name": "Business Class Bus Hire Pune",
      "description": "Travel in style with Amruta Travels' business class bus hire services in Pune, offering luxurious buses for corporate travel."
    },
    {
      "name": "Elegant AC Bus for Tour",
      "description": "Amruta Travels provides elegant AC buses for tours in Pune, offering comfortable and stylish buses for sightseeing and leisure trips."
    }
  ],
  "tableData": [
    ["Premium Bus Rental Pune", "Top Luxury Bus Service Pune"],
    ["Volvo/Bharat Benz/Tata AC Bus Hire", "Luxury Wedding Bus"],
    ["Corporate Executive Bus Service", "AC Luxury Bus for Outstation"],
    ["Event VIP Bus Pune", "45 Seater Deluxe Bus Hire"],
    ["Pune to Pan India Luxury Bus", "High-End Bus Service Pune"],
    ["Volvo Sleeper Bus Rental", "Festival Group Bus Luxury Pune"],
    ["Amruta Travels Premium Buses", "Business Class Bus Hire Pune"],
    ["Elegant AC Bus for Tour"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Best Luxury Bus Hire in Pune – Amruta Travels",
    "WhyChoosedescription": "Amruta Travels is known for offering the best luxury bus hire services in Pune, with a fleet of high-end AC buses perfect for weddings, corporate travel, outstation tours, and special events. Our focus is on providing premium comfort, top-tier service, and reliable travel experiences."
  },
  {
    "WhyChooseheading": "Premium Fleet with World-Class Comfort",
    "WhyChoosedescription": "Our luxury buses come equipped with plush pushback or sleeper seats, air-conditioning, large tinted windows, ample legroom, and onboard entertainment systems. Whether it’s a short trip or an overnight journey, comfort is guaranteed."
  },
  {
    "WhyChooseheading": "Perfect for Weddings, Corporate Events, and VIP Travel",
    "WhyChoosedescription": "From transporting wedding guests in style to arranging elite travel for business executives, our luxury buses are ideal for high-profile events. We ensure punctuality, elegance, and a smooth travel experience for every occasion."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs and Support Staff",
    "WhyChoosedescription": "Our drivers are professionally trained, courteous, and experienced in handling luxury travel. They are well-versed with Pune city and intercity routes, ensuring timely, smooth, and safe journeys for all passengers."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses",
    "WhyChoosedescription": "Each luxury bus in our fleet is regularly cleaned, sanitized, and maintained to the highest standards. You travel in a vehicle that is not only luxurious but also hygienic and road-ready at all times."
  },
  {
    "WhyChooseheading": "Flexible Packages and Transparent Pricing",
    "WhyChoosedescription": "We offer customized rental packages based on your travel needs, group size, and itinerary. Our pricing is fully transparent, with no hidden costs—covering fuel, tolls, driver fees, and taxes."
  },
  {
    "WhyChooseheading": "Pan India Travel and Outstation Experts",
    "WhyChoosedescription": "Our luxury bus hire services extend beyond Pune. Whether you’re headed to Lonavala, Mumbai, Goa, Shirdi, or anywhere across India, Amruta Travels ensures reliable luxury transport solutions for long-distance and outstation travel."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
    "WhyChoosedescription": "With our seamless booking process—online, phone, or in-person—you can reserve your luxury bus in minutes. Our 24/7 customer service team is always available to assist with your booking, special requests, and travel coordination."
  }
]






























    }

const faqData = [
  {
    question: 'Does Amruta Travels offer luxury bus hire in Pune?',
    answer: 'Yes, Amruta Travels provides premium luxury buses for hire in Pune. Our fleet includes top-tier models like Volvo, Bharat Benz, and Tata luxury coaches equipped with modern amenities for a superior travel experience.',
  },
  {
    question: 'What types of luxury buses are available?',
    answer: 'We offer a range of luxury buses including 24-seater, 32-seater, 36-seater, 45-seater, and 53-seater options. These buses come with plush seating, air conditioning, entertainment systems, and spacious interiors for ultimate comfort.',
  },
  {
    question: 'Are luxury buses suitable for both local and outstation travel?',
    answer: 'Absolutely. Our luxury buses are ideal for both local use within Pune and long-distance outstation trips to destinations like Mumbai, Goa, Shirdi, Bangalore, Mahabaleshwar, and more.',
  },
  {
    question: 'What amenities are included in luxury buses?',
    answer: 'Luxury buses from Amruta Travels include features like reclining leather seats, air conditioning, USB charging ports, LED screens, music systems, clean restrooms (in select models), and ample luggage space.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Yes, all our buses are thoroughly cleaned, sanitized, and serviced before every trip. We follow strict hygiene and maintenance protocols to ensure passenger safety and comfort.',
  },
  {
    question: 'Is a professional driver included with the luxury bus rental?',
    answer: 'Yes, all rentals include a trained and experienced driver who ensures a smooth, safe, and timely journey. Our drivers are familiar with major routes and prioritize passenger satisfaction.',
  },
  {
    question: 'How much does it cost to hire a luxury bus in Pune?',
    answer: 'Luxury bus hire pricing varies based on bus type, travel distance, and duration. Rates typically range from ₹35–₹60 per km. Please contact us for a customized quote based on your itinerary.',
  },
  {
    question: 'How do I book a luxury bus in Pune with Amruta Travels?',
    answer: 'You can book a luxury bus online through our website or by calling our customer service. We offer transparent pricing, route planning support, and quick booking confirmation.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Harshad Patil',
    role: 'Wedding Planner, Pune',
    text: 'We hired a 45-seater luxury bus for a wedding event in Pune. The interiors were elegant, the seats were extremely comfortable, and the entire service was professional. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anuja Gokhale',
    role: 'Corporate HR Manager',
    text: 'Our company hired a luxury coach from Amruta Travels for an outstation team event. The bus was top-class, and the journey was smooth and enjoyable. Excellent service and support throughout.',
    rating: 5,
  },
];



































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Luxury Bus Hire in Pune",
  "image": "https://bushireinpune.com/assets/images/luxury-bus-hire-pune.jpg",
  "description": "Experience the best luxury bus hire in Pune with Amruta Travels. Choose from high-end AC buses including Volvo, Bharat Benz, and Tata for weddings, corporate events, outstation trips, and group tours. Our premium buses offer business-class comfort, modern interiors, and professional drivers for VIP, festival, and long-distance travel across India.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "30000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/best-luxury-bus-hire-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Best Luxury Bus Hire in Pune | Premium AC Volvo, Bharat Benz, Tata Bus Rental</title>
  <meta 
    name="description" 
    content="Hire the best luxury bus in Pune with Amruta Travels. Choose premium AC buses like Volvo, Bharat Benz, and Tata for weddings, executive travel, corporate tours, and VIP events across India." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bestluxurybushire;